import {
  IMaintenanceProcess,
  IMaintenanceProcessRule,
  TCreateMaintenanceProcessDTO,
  TCreateMaintenanceProcessRuleDTO,
} from '../maintenance.types.ts'

const initialRules: TCreateMaintenanceProcessRuleDTO[] = [
  { period: 'M1', blankSchemaId: null },
  { period: 'M3', blankSchemaId: null },
  { period: 'M6', blankSchemaId: null },
  { period: 'M9', blankSchemaId: null },
  { period: 'M12', blankSchemaId: null },
]

const generateCreateProcessDTO = (): TCreateMaintenanceProcessDTO => ({
  name: '',
  rules: initialRules,
  equipmentModels: [],
})

const generateUpdateProcessDTO = (currentProcess: IMaintenanceProcess): TCreateMaintenanceProcessDTO => ({
  name: currentProcess.name,
  equipmentModels: currentProcess.equipmentModels,
  rules: [
    ...currentProcess.rules,
    ...initialRules.filter((r) => !currentProcess.rules.some((existingRule) => existingRule.period === r.period)),
  ],
})

const generateRuleDTO = (): TCreateMaintenanceProcessRuleDTO => ({
  period: 'M6',
  blankSchemaId: null,
})

const getPeriodName = (p: IMaintenanceProcessRule['period']) => {
  let res = 'Каждые '
  switch (p) {
    case 'M1':
      return 'Каждый месяц'
    case 'M3':
      return res + '3 месяца'
    case 'M6':
      return res + '6 месяцев'
    case 'M9':
      return res + '9 месяцев'
    case 'M12':
      return res + '12 месяцев'
  }
}

const maintenanceProcessesUtils = { generateCreateProcessDTO, generateUpdateProcessDTO, generateRuleDTO, getPeriodName }
export default maintenanceProcessesUtils
